import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StationSelectComponent } from './station-select.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [StationSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [StationSelectComponent],
})
export class StationSelectModule {}
